export const common = {
  welcome: "Welcome",
  login: "Login",
  logout: "Logout",
  signup: "Sign Up",
  appName: "Open Buildings Platform",
  loading: "Loading...",
  error: "Error",
  success: "Success",
  save: "Save",
  saved: "Saved successfully",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  create: "Create",
  close: "Close",
  view: "View",
  submit: "Submit",
  next: "Next",
  previous: "Previous",
  back: "Back",
  search: "Search",
  filter: "Filter",
  sort: "Sort",
  reset: "Reset",
  select: "Select",
  add: "Add",
  remove: "Remove",
  actions: "Actions",
  name: "Name",
  description: "Description",
  date: "Date",
  status: "Status",
  type: "Type",
  category: "Category",
  uploadingFile: "Uploading file...",
  uploadSuccess: "File uploaded successfully",
  uploadError: "Error uploading file",
  lastUpdated: "Last Updated",
  noData: "No data available",
  all: "All",
  active: "Active",
  inactive: "Inactive",
  viewMore: "View More",
  viewLess: "View Less",
  saveChanges: "Save Changes",
  discardChanges: "Discard Changes",
  unsavedChangesPrompt: "You have unsaved changes. Are you sure you want to leave?",
  confirmDelete: "Confirm Delete",
  confirmDeleteDescription: "Are you sure you want to delete this? This action cannot be undone.",
  yes: "Yes",
  no: "No",
  address: "Address",
  city: "City",
  country: "Country",
  zipCode: "Zip Code",
  phone: "Phone",
  email: "Email",
  website: "Website",
  notAvailable: "Not available",
  darkMode: "Dark Mode",
  lightMode: "Light Mode",
  info: "Information",
  warning: "Warning",
  viewBuildings: "View Buildings",
  semanticSearch: "Semantic Search",
  changeLanguage: "Change Language",
  logoutSuccess: "Logged out successfully",
  logoutError: "Error logging out",
  authRequired: "Authentication required",
  notFound: "Not Found",
  notFoundDescription: "The page you are looking for does not exist.",
  goHome: "Go to Home",
  pageNotFound: "Oops! Page not found",
  returnHome: "Return to Home",
  continueEditing: "Continue Editing",
  saveAndExit: "Save and Exit",
  totalResults: "Total Results",
  settings: "Settings",
  profile: "Profile",
  allBuildings: "All Buildings",
  myAccount: "My Account",
  help: "Help",
  support: "Support",
  contactUs: "Contact Us",
  about: "About",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  version: "Version",
  uploadPhotos: "Upload Photos",
  takePhoto: "Take Photo",
  shareLink: "Share Link",
  copyLink: "Copy Link",
  linkCopied: "Link copied to clipboard",
  downloadPDF: "Download PDF",
  printDocument: "Print Document",
  refreshData: "Refresh Data",
  retry: "Retry",
  accessDenied: "Access Denied",
  notAuthorized: "Not Authorised",
  sessionExpired: "Session Expired",
  pleaseReconnect: "Please reconnect",
  continue: "Continue",
  expandAll: "Expand All",
  collapseAll: "Collapse All",
  showMore: "Show More",
  showLess: "Show Less",
  saving: "Saving...",
  processing: "Processing...",
  done: "Done",
  reports: "Reports",
  comingSoon: "Coming Soon",
  beta: "Beta",
  notifications: "Notifications",
  markAllAsRead: "Mark All as Read",
  clearAll: "Clear All",
  yesterday: "Yesterday",
  today: "Today",
  tomorrow: "Tomorrow",
  filterPanel: {
    remove: "Remove",
    more: "+{count} more",
    active: "Active filters",
    clearAll: "Clear all",
    search: "Search filters…",
    clearSearch: "Clear search",
    noMatches: "No matches for ‘{query}’",
  },
  noOrganization: "No Organisation Selected",
  enterEmail: "Enter email",
  getAccess: "Get Access",
  requestDemo: "Request Demo",
  home: "Home",
  personalSettings: "Personal Settings",
  organizationSettings: "Manage organisation",
  switchedTo: "Switched to",
  selectOrganization: "Select Organisation",
  noOrganizationsFound: "No Organisations Found",
  refresh: "Refresh",
  total: "Total",
  errorSavingChanges: "Error saving changes",
  loadingError: "Error loading data",
  dashboard: "Dashboard",
  // Admin dashboard related translations
  adminDashboard: "Admin Dashboard",
  users: "Users",
  userManagement: "User Management",
  registeredUsers: "Registered Users",
  manageUsers: "Manage Users",
  buildings: "Buildings",
  totalBuildings: "Total Buildings",
  documents: "Documents",
  uploadedDocuments: "Uploaded Documents",
  adminSettings: "Admin Settings",
  systemSettings: "System Settings",
  noOrganizationSelected: "No Organisation Selected",
  settingsSaved: "Settings saved successfully",
  errorSavingSettings: "Error saving settings",
  manageOrgSettings: "Manage Organisation Settings",
  organizationName: "Organisation Name",
  saveSettings: "Save Settings",
  userRoles: "User Roles",
  manageUserRoles: "Manage User Roles",
  userRolesDescription: "Assign roles to users in your organisation",
  allowUserInvites: "Allow User Invites",
  allowUserInvitesDescription: "Let members invite new users",
  enforceEmailDomain: "Enforce Email Domain",
  enforceEmailDomainDescription: "Only allow specific email domains to register",
  allowedDomains: "Allowed Domains",
  adminOnly: "Admin Only",
  general: "General",
  security: "Security",
  generalSettings: "General Settings",
  configureSystemSettings: "Configure System Settings",
  systemName: "System Name",
  publicRegistration: "Public Registration",
  allowNewUsers: "Allow New Users",
  maintenanceMode: "Maintenance Mode",
  temporarilyDisableAccess: "Temporarily Disable Access",
  logLevel: "Log Level",
  securitySettings: "Security Settings",
  configureSecuritySettings: "Configure Security Settings",
  enforceStrongPasswords: "Enforce Strong Passwords",
  requireComplexPasswords: "Require Complex Passwords",
  enableMFA: "Enable MFA",
  requireMFAForSecurity: "Require MFA for Security",
  sessionTimeout: "Session Timeout",
  maxLoginAttempts: "Max Login Attempts",
  settingsReset: "Settings Reset",
  invitations: "Invitations",
  pendingInvitations: "Pending invitations to join organisations",
  noPendingInvitations: "No pending invitations",
  pipelines: "Pipelines",
  pipelinesComingSoon: "Pipeline Management Coming Soon",
  pipelinesDescription: "Monitor and manage document processing pipelines",
  pipelinesFeatures: {
    title: "Upcoming Features",
    monitoring: "Real-time pipeline monitoring",
    configuration: "Pipeline configuration management",
    logs: "Detailed processing logs",
    metrics: "Performance metrics and analytics",
    alerts: "Pipeline failure alerts",
  },
  createNewOrganization: "Create New Organisation",
  userSettings: "My settings",
  language: "Language",
  organization: "Organisation",
  organizationSelected: "Organisation selected",
  organizationSwitched: "You've switched to {name}.",
  invalidName: "Invalid name",
  organizationNameMinLength: "Organisation name must be at least 2 characters long.",
  userNotFound: "User not found. Please try logging in again.",
  organizationCreatedSuccess: 'Organisation "{name}" created successfully.',
  createOrgDialogTitle: "Create New Organisation",
  createOrgDialogDescription:
    "Enter a name for your new organisation. This name can be changed later.",
  organizationNameLabel: "Organisation Name",
  organizationNamePlaceholder: "Enter organisation name",
  creating: "Creating...",
  applicationError: "Application Error",
  unexpectedError: "An unexpected error occurred.",
  reloadPage: "Reload Page",
  tryAgain: "Try Again",
  retryAttempt: "Retry attempt: {n}/3",
  sending: "Sending...",
  generating: "Generating...",
  role: "Role",
  somethingWentWrong: "Something went wrong:",
  area: "Area...",
  units: "Units",
  count: "Count...",
  yearPlaceholder: "YYYY",
  seconds: "seconds",
  complete: "Complete",
  loadingOrgContext: "Loading organisation context...",
  viewerDifferencesNotice:
    "Differences are detected automatically and may not capture every change. Always validate the results against the source files.",
  viewerAccuracyNotice: {
    reference: {
      summary:
        "For reference viewing. Some file elements may not be fully represented. Use the original file for authoritative review.",
      title: "About file viewing",
      body: "Franklin provides a convenient view of DWG and IFC files. Some file elements, properties or references may not be fully represented in the viewer. For decisions requiring complete or authoritative file information, refer to the original source file.",
    },
    comparison: {
      summary:
        "Franklin helps identify differences between file versions. Automated comparison may not detect every change.",
      title: "About comparison accuracy",
      body: "Franklin is designed to assist with reviewing changes between file versions. Automated comparison results may be incomplete or inaccurate and may include missed or incorrectly identified changes. For critical design, engineering, construction or compliance decisions, the source files should be independently reviewed.",
    },
  },
  permissions: {
    denied: "Permission Denied",
    archiveBuildings: "You don't have permission to archive buildings.",
    restoreBuildings: "You don't have permission to restore buildings.",
    createBuildings: "You don't have permission to create buildings.",
    editBuildings: "You don't have permission to edit buildings.",
    defaultMessage: "You don't have permission to perform this action.",
    projectAction: "You don't have permission to {action} in this project.",
    anyProjectAction: "You don't have permission to {action} in any of your projects.",
    ask: "Ask someone to give you access.",
    noAccessTitle: "You don't have access",
    goToBuildings: "Go to buildings",
    actions: {
      manageIssues: "create and edit issues",
      addFiles: "upload files or create folders",
      deleteFiles: "permanently delete files",
      manageContacts: "add or edit contacts",
      viewIssues: "see issues",
      useDrawingViewer: "use the drawing viewer",
      useModelViewer: "use the model viewer",
      viewContacts: "see contacts",
    },
  },
};
